<template>
  <div ref="menuContainer" class="menu-container" v-bind:style="`position: ${absolute ? 'absolute' : 'relative'}; width: ${visible};`">
    <div class="vertical">
        <div class="language-picker-menu">
            <div style="display: flex;">
                <select class="language-selector" v-model="selLanguage" @change="$emit('changeLanguage', selLanguage)">
                    <option :value="'English'">🇬🇧 English</option>
                    <option :value="'Polish'">🇵🇱 Polski</option>
                    <!-- <option :value="'Norwegian'">🇳🇴 Norsk</option> -->
                    <!-- <option :value="'Translation'">Translation</option> -->
                </select>
            </div>
        </div>
        <!-- When system is active -->
        <navigation-menu-router v-if="$route.params.systemName != undefined" :title="$route.params.systemName" :routerTo="'settingsGeneral'" :params="$route.params" :hasDropdown="true" :alwaysDropdown="true" style="border-bottom: 1px lightgrey solid; padding: 10px 0; margin: 10px 0;">
            <template v-slot:dropdown>
                <navigation-menu-router-dropdown>
                    <template v-slot:elements>
                        <navigation-menu-router :title="'Tasks'" :routerTo="'systemsTasks'" :params="$route.params">
                            <template v-slot:icon>
                                <img v-if="$store.getters.hasTasks == null" src="@/assets/img/Menu/Todo-null.svg"/>
                                <img v-else-if="$store.getters.hasTasks" src="@/assets/img/Menu/Todo.svg"/>
                                <img v-else src="@/assets/img/Menu/Todo-none.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Animals'" :routerTo="'systemAnimals'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Animals_Cow.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Devices'" :routerTo="'settingsDevices'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Roughage.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router v-if="notUser" :title="'DeviceAlarms'" :routerTo="'settingsAlarms'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Alarms.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router v-if="notUser" :title="'General Alarms'" :routerTo="'systemsGeneralAlarms'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Alarms.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Roughage'" :routerTo="'settingsRoughage'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Roughage.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Sorting'" :routerTo="'settingsSorting'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Sorting.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Statistics'" :routerTo="'settingsStatistics'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Statistics.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router v-if="notUser" :title="'Visits'" :routerTo="'systemVisits'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Service.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router v-if="notUser" :title="'Problems'" :routerTo="'settingsProblems'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Service.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router v-if="notUser" :title="'Settings'" :routerTo="'systemSettings'" :params="$route.params">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Settings.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router v-if="notUser" :title="'Tickets'" :routerTo="'systemTickets'" :params="$route.params">
                            <template v-slot:icon>
                                <img id="noTickets" src="@/assets/img/Systems/MessageSmall.svg"/>
                                <img id="tickets" src="@/assets/img/Systems/MessageNewMailSmall.svg"/>
                            </template>
                        </navigation-menu-router>
                    </template>
                </navigation-menu-router-dropdown>
            </template>
        </navigation-menu-router>
        <!-- Always active -->
        <navigation-menu-router :title="'Systems'" :routerTo="'systems'" :hasDropdown="true" :alwaysDropdown="$store.getters.isUser">
            <template v-slot:icon>
                <img src="@/assets/img/Menu/Systems.svg"/>
            </template>
            <template v-slot:dropdown>
                <navigation-menu-router-dropdown>
                    <template v-slot:elements>
                        <navigation-menu-router :title="'Map'" :routerTo="'map'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Maps.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Dashboard'" :routerTo="'dashboard'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Dashboard.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router v-if="!$store.getters.isUser" :title="'Weights'" :routerTo="'weights'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/chart.svg"/>
                            </template>
                        </navigation-menu-router>
                    </template>
                </navigation-menu-router-dropdown>
            </template>
        </navigation-menu-router>
        <navigation-menu-router v-if="$store.getters.isAdmin" :title="'Users'" :routerTo="'users'" :hasDropdown="true">
            <template v-slot:icon>
                <img src="@/assets/img/Menu/Users.svg"/>
            </template>
            <template v-slot:dropdown>
                <navigation-menu-router-dropdown>
                    <template v-slot:elements>
                        <navigation-menu-router :title="'Invitations'" :routerTo="'invitations'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Users.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Contacts'" :routerTo="'contacts'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Menu/Contact.svg"/>
                            </template>
                        </navigation-menu-router>
                    </template>
                </navigation-menu-router-dropdown>
            </template>
        </navigation-menu-router>
        <navigation-menu-router v-else-if="$store.getters.isService" :title="'Contacts'" :routerTo="'contacts'">
            <template v-slot:icon>
                <img src="@/assets/img/Menu/Contact.svg"/>
            </template>
        </navigation-menu-router>
        <navigation-menu-router v-if="notUser" :title="'Alarms'" :routerTo="'alarms'">
            <template v-slot:icon>
                <img src="@/assets/img/Menu/Alarms.svg"/>
            </template>
        </navigation-menu-router>
        <navigation-menu-router v-if="notUser" :title="'Service'" :routerTo="'visits'" :hasDropdown="true">
            <template v-slot:icon>
                <img src="@/assets/img/Menu/Service.svg"/>
            </template>
            <template v-slot:dropdown>
                <navigation-menu-router-dropdown>
                    <template v-slot:elements>
                        <navigation-menu-router :title="'Visits'" :routerTo="'visitsList'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Roughage.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Problems'" :routerTo="'visitsProblems'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Roughage.svg"/>
                            </template>
                        </navigation-menu-router>
                        <navigation-menu-router :title="'Solutions'" :routerTo="'visitsSolutions'">
                            <template v-slot:icon>
                                <img src="@/assets/img/Systems/Roughage.svg"/>
                            </template>
                        </navigation-menu-router>
                    </template>
                </navigation-menu-router-dropdown>
            </template>
        </navigation-menu-router>
        <navigation-menu-router v-if="$store.getters.isAdmin" :title="'Cloud'" :routerTo="'cloud'">
            <template v-slot:icon>
                <img src="@/assets/img/Menu/cloud.svg"/>
            </template>
        </navigation-menu-router>
        <navigation-menu-router :title="'FAQ'" :routerTo="'faq'">
            <template v-slot:icon>
                <img src="@/assets/img/Menu/FAQ.svg"/>
            </template>
        </navigation-menu-router>
    </div>
  </div>
</template>

<script>
import NavigationMenuRouterDropdown from './NavigationMenuRouterDropdown.vue'
import NavigationMenuRouter from './NavigationMenuRouter.vue'

export default {
    components: {
        NavigationMenuRouter,
        NavigationMenuRouterDropdown
    },
    props: {
        isVisible: {
            type: Boolean,
            default: true,
            required: true
        },
        absolute: {
            type: Boolean,
            default: false,
            required: false
        },
        selectedLanguage: {
            type: String,
            required: true
        }
    },
    computed: {
        visible() {
            return this.isVisible ? '250px' : '0px'
        },
        notUser() {
            return this.$store.getters.isAdmin || this.$store.getters.isService;
        }
    },
    // watch: {
    //     isVisible(newVal, oldVal) {
    //         if (newVal) {
    //             this.open()
    //         } else {
    //             this.close()
    //         }
    //     }
    // },
    data() {
        return {
            selLanguage: 'English'
        }
    },
    methods: {
        open() {
            this.$refs.menuContainer.style.width = '0px'
        },
        close() {
            this.$refs.menuContainer.style.width = '250px'
        }
    },
    mounted() {
        this.$nextTick(_ => {
            this.selLanguage = this.selectedLanguage
        })
    }
}
</script>

<style scoped>
.menu-container {
    transition: 0.3s ease-out;
    display: block;
    z-index: 4;
    background-color: #414F51;
    height: calc(100vh - 50px);
    overflow-y: auto;
    overflow-x: hidden;
    width: 250px;
}

.language-picker-menu {
    display: none;
}

@media only screen and (max-width: 700px) {
    .menu-container {
        position: absolute !important;
    }

    .language-picker-menu {
        margin: 0 20px;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-bottom: solid 1px gray;
        border-top: solid 1px gray;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/Main/Menu/NavigationMenu.vue